import type { RouterTransitionType } from "next"

let pendingScrollUrl: string | null = null

export function onRouterTransitionStart(
  href: string,
  type: RouterTransitionType,
) {
  const target = new URL(href, window.location.href)
  pendingScrollUrl =
    type !== "traverse" &&
    !target.hash &&
    target.origin === window.location.origin
      ? target.href
      : null

  // Selecting the current page again does not produce a new URL to observe.
  scrollToTopIfArrived()
}

export function scrollToTopIfArrived() {
  if (pendingScrollUrl !== window.location.href) return
  pendingScrollUrl = null
  window.scrollTo({ top: 0, left: 0, behavior: "instant" })
}
